import * as React from 'react';
import { TableSortLabel, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, Paper, Select, MenuItem, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button, Box } from '@mui/material';
// import Table from '@mui/material/Table';
// import TableBody from '@mui/material/TableBody';
// import TableCell from '@mui/material/TableCell';
// import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
// import TableRow from '@mui/material/TableRow';
// import Paper from '@mui/material/Paper';
// import TablePagination from '@mui/material/TablePagination';
import { Wrapper, theme } from "./style";
import { ThemeProvider } from '@mui/material/styles';
import { observer } from "mobx-react";
import { useHorsesStore } from "../../../stores/horses";
import { visuallyHidden } from '@mui/utils';
function createData(
    name: string,
    calories: number,
    fat: number,
    carbs: number,
    protein: number,
) {
    return { name, calories, fat, carbs, protein };
}



const BasicTable = () => {
    const stores = useHorsesStore()
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [count, setCount] = React.useState(0);
    const [open, setOpen] = React.useState(false);
    const [selectedStatus, setSelectedStatus] = React.useState(null);
    const [selectedId, setSelectedId] = React.useState(null);
    const [sortField, setSortField] = React.useState(null);
    const [sortOrder, setSortOrder] = React.useState<"asc" | "desc">('asc');

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        stores.getAllEvent(newPage + 1);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const submitStatusChange = () => {

        if (selectedId && selectedStatus) {
            stores.changeCalendarStatus(selectedId, selectedStatus);
        }

        setOpen(false);
    };

    const handleStatusChange = (id, status) => {
        setSelectedId(id);
        setSelectedStatus(status);
        if (status === 'Delete') {
            setOpenDeleteDialog(true);
        } else {
            setOpen(true);
        }
    };

    const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false);

    const handleDeleteClose = () => {
        setOpenDeleteDialog(false);
    };

    const submitDelete = () => {
        if (selectedId) {
            stores.changeCalendarStatus(selectedId, 'Delete');
        }
        setOpenDeleteDialog(false);
    };
    const handleSort = (field) => {
        setSortField(field);
        setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    };

    React.useEffect(() => {
        if (stores.getUserRole()) {
            stores.getAllEvent(page + 1, false, sortField, sortOrder).then(res => setCount(res.total))
        }
    }, [sortOrder, sortField])

    return (
        <ThemeProvider theme={theme}>
            <Wrapper padding={16}>
                {stores.getUserRole() && <TableContainer component={Paper} >
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                            <TableRow>

                                <TableCell>Name</TableCell>
                                <TableCell align="right">Type</TableCell>
                                <TableCell align="right">Regions</TableCell>
                                <TableCell align="right">User Name</TableCell>
                                <TableCell align="right">Email</TableCell>
                                <TableCell align="right">Start Date</TableCell>
                                <TableCell align="right">End Date</TableCell>
                                <TableCell align="right">Address</TableCell>
                                <TableCell align="right">Description</TableCell>
                                <TableCell align="right">
                                    <TableSortLabel
                                        active={true}
                                        direction={sortOrder}
                                        onClick={() => handleSort('cct_created')}
                                    >
                                        Create Date
                                        <Box component="span" mr={2}>
                                            {sortOrder === 'desc' ? '(sorted descending) ' : '(sorted ascending) '}
                                        </Box>
                                    </TableSortLabel>
                                </TableCell>
                                <TableCell align="right">
                                    <TableSortLabel
                                        active={true}
                                        direction={sortOrder}
                                        onClick={() => handleSort('status')}
                                    >
                                        Status
                                        <Box component="span" mr={2}>
                                            {sortOrder === 'desc' ? '(sorted descending) ' : '(sorted ascending) '}
                                        </Box>
                                    </TableSortLabel>
                                </TableCell>

                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {stores.calendar.map((row) => (
                                <TableRow
                                    key={row._ID}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >

                                    <TableCell component="th" scope="row">
                                        {row.description}
                                    </TableCell>
                                    <TableCell align="right">{row.public_type}</TableCell>
                                    <TableCell align="right">{row.regions}</TableCell>
                                    <TableCell align="right">{row.usrName}</TableCell>
                                    <TableCell align="right">{row.usrEmail}</TableCell>
                                    <TableCell align="right">{row.date.format('DD/MM/YYYY-HH:mm')}</TableCell>
                                    <TableCell align="right">{row.endDate ? row.endDate.format('DD/MM/YYYY-HH:mm') : row.date.format('DD/MM/YYYY-HH:mm')}</TableCell>
                                    <TableCell align="right">{row.address}</TableCell>
                                    <TableCell align="right">{row.notes}</TableCell>
                                    <TableCell align="right">{row.createDate}</TableCell>
                                    <TableCell align="right">
                                        <Select
                                            variant='standard'
                                            value={row.status}
                                            onChange={(event) => handleStatusChange(row._ID, event.target.value)}
                                        >
                                            <MenuItem value={'Draft'}>Draft</MenuItem>
                                            <MenuItem value={'Published'}>Published</MenuItem>
                                            <MenuItem value={'Rejected'}>Rejected</MenuItem>
                                            <MenuItem value={'Delete'}>Delete</MenuItem>
                                        </Select>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>

                    </Table>
                </TableContainer>}

                <TablePagination

                    component="div"
                    count={count}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />

                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Confirm Status Change"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Are you sure you want to change the status to {selectedStatus}?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Cancel</Button>
                        <Button onClick={submitStatusChange} autoFocus>Ok</Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={openDeleteDialog}
                    onClose={handleDeleteClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Confirm Delete"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Are you sure you want to delete this item?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleDeleteClose}>Cancel</Button>
                        <Button onClick={submitDelete} autoFocus>Ok</Button>
                    </DialogActions>
                </Dialog>
            </Wrapper>

        </ThemeProvider>

    );
}

export default observer(BasicTable)